define(['text!./templates/readonly-coverages.html','underscore'],
    (templateStr, _)=> {
    return [()=> {
        return {
            restrict: 'A',
            template: templateStr,
            scope: {
                coverages: '=?gwQnbReadonlyCoverages',
                lob: '@'
            },
            controller: ['$scope', (scope)=> {
                coveragesArray = ['HODW_SectionI_Ded_HOE','HODW_Dwelling_Cov_HOE','HODW_Other_Structures_HOE','HODW_Personal_Property_HOE','HODW_Loss_Of_Use_HOE','HOLI_Personal_Liability_HOE','HOLI_Med_Pay_HOE'
                    ,'AdditionalAmtInsHOE_aaa','ReplacementCost_ContentsCovHOE_aaa','ReplacementCostDweling_aaa','Refrigerated_PP_CovHOE_aaa','AccidentalDeathHOE_aaa','Identity_Fraud_Exp_Cov_aaa','WaterBackup_Sump_CovHOE_aaa',
                    'HOLI_PersonalInjury_HOE','Service_Line_Coverage_aaa','Home_Systems_Protection_aaa','Inland_Flood_Coverage_aaa','zk4gep2qoal242a7j69fqqc2489','zbmheeo71ls731ema216p58g9t9','zugggoahqeqao6efk0m7r8afbja','CICovAHOE_aaa'];

                scope.model = scope.coverages.filter((coverage)=> {
                        return coverage.selected;
                });
                if(scope.lob === 'Homeowners') {
                    scope.selectedCoverages = _.filter(scope.model, function (item) {
                        if (coveragesArray.indexOf(item.publicID) != -1) return item;
                    });
                }else{
                    scope.selectedCoverages = scope.model;
                }
            }]
        };
    }];
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/common/directives/ReadonlyCoverages.js
 **/